<template><div><h1 id="adressimport-uber-excel-csv" tabindex="-1"><a class="header-anchor" href="#adressimport-uber-excel-csv"><span>Adressimport über Excel/CSV</span></a></h1>
<h2 id="_1-arten-des-adressimports" tabindex="-1"><a class="header-anchor" href="#_1-arten-des-adressimports"><span>1. Arten des Adressimports</span></a></h2>
<h3 id="_1-1-welche-adressimportmethode-sollst-du-verwenden" tabindex="-1"><a class="header-anchor" href="#_1-1-welche-adressimportmethode-sollst-du-verwenden"><span>1.1 Welche Adressimportmethode sollst du verwenden?</span></a></h3>
<p><strong>Adressimport in eigene Datenbank:</strong></p>
<ul>
<li>Diese Methode ist geeignet, um eine grosse Anzahl an Adressen in deine eigene Datenbank zu importieren.</li>
<li>Fehlerhafte Adressen werden ausgeschlossen und müssen ausserhalb von funtrade berichtigt werden.</li>
<li>Ideal für Massenimporte oder Importe in Fremddatenbank.</li>
</ul>
<p><strong>Adressimport mit manueller Zuordnung:</strong></p>
<ul>
<li>Mit dieser Methode kannst du jede fehlerhafte Adresse manuell korrigieren, bevor sie importiert wird.</li>
<li>Ausserdem kannst du so Zahlungen (&quot;Response-Ereignisse&quot;) erstellen, indem Zahlungen von Plattformen wie RaiseNow oder Payrexx aus CSV oder Excel importiert werden.</li>
<li>Empfohlen für kleinere Datensätze, bei denen Korrekturmöglichkeiten erforderlich sind.</li>
</ul>
<h2 id="_2-grundlagen" tabindex="-1"><a class="header-anchor" href="#_2-grundlagen"><span>2. Grundlagen</span></a></h2>
<h3 id="_2-1-zuordnung-der-spalten-im-excel-auf-informationen-in-funtrade" tabindex="-1"><a class="header-anchor" href="#_2-1-zuordnung-der-spalten-im-excel-auf-informationen-in-funtrade"><span>2.1 Zuordnung der Spalten im Excel auf Informationen in funtrade</span></a></h3>
<h4 id="_2-1-1-adressimport-positionen-spaltenubersicht" tabindex="-1"><a class="header-anchor" href="#_2-1-1-adressimport-positionen-spaltenubersicht"><span>2.1.1 Adressimport-Positionen: Spaltenübersicht</span></a></h4>
<ul>
<li>von / bis: welche Spaltennummer im Excel</li>
<li>Feld: Welche Information ist in dieser Spalte enthalten</li>
<li>Parameter: Zusatzinformation für Zuordnung, siehe Beispiele unten</li>
<li>Codierung: siehe <code v-pre>2.1.2. Codierung</code> unten</li>
</ul>
<p><img src="@source/tutorial/i/adressimport/00_einstieg.png" alt="Übersicht"></p>
<h4 id="_2-1-2-codierung" tabindex="-1"><a class="header-anchor" href="#_2-1-2-codierung"><span>2.1.2 Codierung</span></a></h4>
<ul>
<li>
<p><strong>Zweck der Codierung:</strong><br>
Mit Hilfe der Codierung kannst du Werte aus dem Excel umwandeln, bevor sie in funtrade importiert werden.</p>
</li>
<li>
<p><strong>Generelle Regeln:</strong></p>
<ul>
<li>
<p><strong>Form</strong>: Die Codierung erfolgt in der Form:  <code v-pre>&quot;WertExcel &gt; WertFuntrade, WertExcel &gt; WertFuntrade&quot;</code></p>
</li>
<li>
<p><strong>Reihenfolge:</strong> Die Codierungen werden von links nach rechts angewendet.</p>
</li>
<li>
<p><strong>Standardwerte setzen:</strong> Mit <code v-pre>*&gt;WertFuntrade</code> kannst du Standardwerte festlegen. Beispiel:</p>
<ul>
<li><code v-pre>fr &gt; f, *&gt;d</code> bedeutet:
<ul>
<li>Falls der Excel-Wert <code v-pre>fr</code> ist, wird er zu <code v-pre>f</code> umgewandelt;</li>
<li>Andernfalls wird er zu <code v-pre>d</code>.</li>
</ul>
</li>
</ul>
</li>
<li>
<p>Wenn keine Codierung angegeben wird, wird der Wert 1:1 übernommen, wie er im Excel steht.</p>
</li>
</ul>
</li>
<li>
<p><strong>Spezialfälle:</strong></p>
<ul>
<li>Es gibt spezielle Codierungen für bestimmte Felder.</li>
<li>Die genauen Codierungen findest du unter folgendem Link: <RouteLink to="/referenz/refs/ft.refdata.adrimppos.html"><code v-pre>Adressimport-Positionen</code></RouteLink></li>
</ul>
</li>
</ul>
<div class="hint-container warning">
<p class="hint-container-title">Hinweis</p>
<p>Überprüfe die Codierungsschritte sorgfältig, um sicherzustellen, dass alle Werte korrekt und wie gewünscht umgewandelt werden.</p>
</div>
<h2 id="_3-tutorial-adressimport-mit-manueller-zuordnung" tabindex="-1"><a class="header-anchor" href="#_3-tutorial-adressimport-mit-manueller-zuordnung"><span>3. Tutorial Adressimport mit manueller Zuordnung</span></a></h2>
<h3 id="ausgangslage" tabindex="-1"><a class="header-anchor" href="#ausgangslage"><span>Ausgangslage</span></a></h3>
<p>Du möchtest ein Excel-File mit Zahlungen importieren:</p>
<ul>
<li><strong>Datenquelle:</strong> Online Payment Plattform RaiseNow</li>
<li><strong>Ziel:</strong> Ein Response-Ereignisse erstellen</li>
<li><strong>Weitere Abbildungen:</strong>
<ul>
<li><strong>Email-Einverständnis:</strong> Wird als Publikation dargestellt</li>
<li><strong>Spendenbescheinigung:</strong> Wird als Merkmal mit einem bestimmten Wert abgebildet</li>
</ul>
</li>
</ul>
<p>Das verwendete Excel File findest du hier zum Download: <a href="https://docs.funtrade.ch/files/adressimport-excel.xlsx" target="_blank" rel="noopener noreferrer">Excel-File</a></p>
<h3 id="schritt-1-adressimport-anlegen" tabindex="-1"><a class="header-anchor" href="#schritt-1-adressimport-anlegen"><span>Schritt 1: Adressimport anlegen</span></a></h3>
<ul>
<li><strong>File hochladen:</strong> Lade die entsprechende Datei in funtrade hoch.</li>
<li><strong>Quelle angeben:</strong> Gib an, woher die Daten stammen (z. B. RaiseNow).</li>
<li><strong>Angaben zum File:</strong>
<ul>
<li>Trage ein, ob es sich um ein Excel- oder CSV-Format handelt.</li>
<li>Wir empfehlen die Verwendung von Excel, falls möglich, da hier weniger Interpretationsprobleme auftreten.</li>
</ul>
</li>
<li><strong>Postalisch unvollständige verarbeiten:</strong> hier immer NEIN wählen</li>
</ul>
<h3 id="schritt-2-importpositionen-zuordnen" tabindex="-1"><a class="header-anchor" href="#schritt-2-importpositionen-zuordnen"><span>Schritt 2: Importpositionen zuordnen</span></a></h3>
<p>In diesem Schritt müssen wir definieren, was mit einer Information aus dem Excel passieren soll. Dabei ordnen wir jeder Spalte aus dem Excel einen bestimmte Informationstyp aus funtrade zu.</p>
<ul>
<li>Als erste ist es wichtig zu verstehen, welche Informationen in unserem Excel vorhanden sind und welche Informationen wir &quot;generell&quot; bzw. für alle Zahlungen zusätzlich zu den Informationen aus dem Excel hinzufügen müssen.</li>
<li>Auch sind in unserem Beispielexcel Informationen über &quot;Fehlerhafte&quot; Zahlungen enthalten, diese wollen wir nicht importieren.</li>
<li>Auch sind im Excel Informationen über &quot;Kartenzahlungen&quot; sowie &quot;TWINT&quot; Zahlungen enthalten. Da wir pro Durchlauf nur ein einzelnes Ereignis mit Ereignisposition setzen können, müssen wir zwei Durchläufe machen und jeweils das eine oder das andere ignorieren.</li>
</ul>
<h4 id="generelle-informationen" tabindex="-1"><a class="header-anchor" href="#generelle-informationen"><span>Generelle Informationen</span></a></h4>
<ul>
<li>Ich möchte für alle Zahlungen das Respons-Ereignis <code v-pre>2025.Freie.Spenden</code> mit der Ereignisposition <code v-pre>TWI</code> für TWINT verwenden.
<ul>
<li>Ich kopiere mit die genauen Namen dieses Ereignisses und der Ereignisposition aus den Ereignissen um Typos zu vermeiden</li>
</ul>
</li>
<li>Jedes Response-Ereignis braucht für die Buchungen ein physisches Konto, auf welchem die Zahlung eingegangen ist. Das ist das <code v-pre>Zahlungskonto</code>. Ich wähle das Konto <code v-pre>1010</code>: ein Postkonto aus dem Kontenplan (<code v-pre>Buchhaltung&gt;Tabellen&gt;Kontoplan: Konti</code>)</li>
</ul>
<p>Die restlichen Informationen finde ich im Excel.</p>
<h4 id="zeile-die-ignoriert-werden-sollen" tabindex="-1"><a class="header-anchor" href="#zeile-die-ignoriert-werden-sollen"><span>Zeile, die ignoriert werden sollen</span></a></h4>
<ul>
<li>Spalte 4: Fehlerhafte Zahlungen i.e. <code v-pre>failed</code></li>
<li>Spalte 14: wenn <code v-pre>card</code>  als Zahlungsmittel angegeben ist</li>
</ul>
<h4 id="finale-definition" tabindex="-1"><a class="header-anchor" href="#finale-definition"><span>Finale Definition</span></a></h4>
<p>Meine Definition der Import-Positionen schaut nun so aus:</p>
<div class="hint-container warning">
<p class="hint-container-title">Hinweis</p>
<p>Achte darauf, dass dein Excel wirklich genau die definierte Werte verwendet. Gross- Kleinschreibung sowie Typos und andere kleine Unterschiede führen bereits dazu, dass der Import nicht richtig funktioniert. Felder mit leeren Werten gelten nicht automatisch als &quot;false&quot; oder ungültig. Diese können über den <code v-pre>*</code> Operator selektiert werden (siehe Kapitel Codierung).</p>
</div>
<p><img src="@source/tutorial/i/adressimport/01_importpositionen.png" alt=""></p>
<h3 id="schritt-3-daten-einlesen" tabindex="-1"><a class="header-anchor" href="#schritt-3-daten-einlesen"><span>Schritt 3: Daten einlesen</span></a></h3>
<p>Sobald wir zuversichtlich sind, dass unsere Importpositionen richtig definiert sind, können wir die Daten einlesen.</p>
<p>Dazu selektieren wir im Kontextmenü: Daten einlesen.</p>
<p><img src="@source/tutorial/i/adressimport/02_daten-einlesen.png" alt=""></p>
<p>Wenn wir nun die Ansicht über aktualisieren (über das Kontextmenü oder in der Toolbar), werden uns im oberen Bereich die Zahlen angezeigt:</p>
<ul>
<li>gesamt <code v-pre>23</code></li>
<li>davon ignoriert: <code v-pre>9</code>
<ul>
<li><code v-pre>2</code> haben nämlich <code v-pre>Status: failed</code></li>
<li><code v-pre>7</code> haben Zahlungsart: <code v-pre>card</code></li>
</ul>
</li>
<li>zu bearbeiten <code v-pre>14</code>
<ul>
<li>diese schauen wir uns im nächsten Schritt genau an</li>
</ul>
</li>
<li>verarbeitet <code v-pre>0</code></li>
</ul>
<p><img src="@source/tutorial/i/adressimport/03_daten-eingelesen.png" alt=""></p>
<h4 id="korrekturen-stimmt-etwas-mit-den-daten-nicht" tabindex="-1"><a class="header-anchor" href="#korrekturen-stimmt-etwas-mit-den-daten-nicht"><span>Korrekturen: Stimmt etwas mit den Daten nicht?</span></a></h4>
<p>Solange du die Daten nur <strong>eingelesen</strong> aber noch nicht <strong>verarbeitet</strong> hast, kannst du die Daten im oberen Fenster über <code v-pre>Kontextmenü &gt; eingelesene Daten zurücksetzen</code> wieder zurücksetzen.</p>
<h3 id="schritt-4-personen-uberprufen-und-zuordnen" tabindex="-1"><a class="header-anchor" href="#schritt-4-personen-uberprufen-und-zuordnen"><span>Schritt 4: Personen überprüfen und zuordnen</span></a></h3>
<p>Nun kommen wir zum spannendsten Teil: die Personen überprüfen.</p>
<p>Im Tab <code v-pre>Import-Zuordnung</code> finden wir die im Excel gefundenen Personen und deren Zuordnung zu bereits in funtrade existierenden Personen. Für die Suche nach Personen werden die selben Kriterien verwendet wie für die Suche nach Dubletten.</p>
<p>Es gibt drei Mögliche Werte für die Spalte <code v-pre>Status</code>:</p>
<ul>
<li><code v-pre>zugeordnet</code>: es wurde eine Person in funtrade gefunden, die mit grosser Wahrscheinlichkeit die selbe ist.</li>
<li><code v-pre>OK</code>: es wurde entweder gar keine oder eine ähnliche Person gefunden aber diese sollte überprüft werden</li>
<li><code v-pre>Fehler</code>: es wurde ein Fehler in den Postdaten gefunden. Diese müssen auch manuell gefixt werden</li>
</ul>
<h4 id="beispiel-fur-zugeordnet" tabindex="-1"><a class="header-anchor" href="#beispiel-fur-zugeordnet"><span>Beispiel für Zugeordnet</span></a></h4>
<p><img src="@source/tutorial/i/adressimport/04_personen-zugeordnet.png" alt=""></p>
<h4 id="beispiel-fur-ok" tabindex="-1"><a class="header-anchor" href="#beispiel-fur-ok"><span>Beispiel für OK</span></a></h4>
<p>Erica Looser ist die Tochter von Ursual Looser. Erica hat das Elternhau übernommen und die Eltern sind ausgezogen. In diesem Fall dürfen wir natürlich die Spende von Erica nicht der Mutter Ursula zuordnen.</p>
<div class="hint-container warning">
<p class="hint-container-title">OK Adressen werden automatisch zugeordnet und verarbeitet</p>
<p>OK Adressen werden beim Verarbeiten automatisch zugeordnet und verarbeitet. Das hat zur Folge, das Treffer mit <code v-pre>Genauigkeit: tief</code> jenachdem falsch zugeordnet werden. Kontrolliere deshalb immer alle <code v-pre>OK</code> Adressen.</p>
</div>
<p><img src="@source/tutorial/i/adressimport/05_personen-OK.png" alt=""></p>
<p>Um das zu korrigieren, erfassen wir Erica als neue Spenderin:</p>
<ul>
<li><code v-pre>Erica&quot; &gt; Rechte Maustaste &gt; Person erfassen und zuordnen</code></li>
</ul>
<p><img src="@source/tutorial/i/adressimport/06_person-zuordnen.png" alt=""></p>
<ul>
<li>Hier passen wir falls nötig die Informationen noch an und wählen <code v-pre>ok</code></li>
<li>Weil auch hier die Dublettenprüfung durchgeführt wird, erhalten wir einen Hinweis, das die Mutter Looser bereits an dieser Adresse wohnt und eine Dublette sein könnte. Das ist nicht der Fall weshalb wir eine <code v-pre>Neue Person erfassen</code> wählen.</li>
</ul>
<p><img src="@source/tutorial/i/adressimport/07_person-hinweis.png" alt=""></p>
<p>Nun ist Erica erfasst und zugeordnet.</p>
<p><img src="@source/tutorial/i/adressimport/08_person-zugeordnet.png" alt=""></p>
<h4 id="fehlerhafte-adressen" tabindex="-1"><a class="header-anchor" href="#fehlerhafte-adressen"><span>Fehlerhafte Adressen</span></a></h4>
<p>Die Fehlerhaften Adresse können korrigiert werden, indem gleich verfahren wird wie oben bei &quot;Beispiel für OK&quot;. In diesem Fall erstellen wir auch eine neuen Person und korrigieren aber die fehlerhaften Daten im Dialog für die Adresserfassung. Falls eine ähnliche Person bereits in funtrade existiert, werden wir auf diese hingewiesen.</p>
<p>Je nach Fehler findet funtrade Personen in der Datenbank obwohl ihre Adresse fehlerhaft ist. In diesem Fall werden diese Kandidaten auf der rechten Seite als <code v-pre>Treffergenauigkeit</code> tief ausgewiesen und können von dort direkt über <code v-pre>Kontextmenü &gt; zuordnen</code> zugeordnet werden.</p>
<div class="hint-container caution">
<p class="hint-container-title">Achtung</p>
<ul>
<li>Kontrolliere die <strong>zugeordnet</strong> Adressen: Hast du solche?</li>
<li>Hast du viele Adressen, die ungültig sind?</li>
<li>Hast du bemerkt, dass beim neu erstellen von Adressen gewisse Felder <strong>falsch</strong> vorausgefüllt wurden? z.B. Sprache <code v-pre>fr</code> statt <code v-pre>f</code>?</li>
</ul>
<p>Solange du die Daten nur <strong>eingelesen</strong> aber noch nicht <strong>verarbeitet</strong> hast, kannst du die Daten im oberen Fenster über <code v-pre>Kontextmenü &gt; eingelesene Daten zurücksetzen</code> wieder zurücksetzen und die Importpositionen wieder bearbeiten...</p>
</div>
<h3 id="schritt-6-daten-verarbeiten" tabindex="-1"><a class="header-anchor" href="#schritt-6-daten-verarbeiten"><span>Schritt 6: Daten verarbeiten</span></a></h3>
<p>Nun, da wir alle Personen kontrolliert haben, können wir die Daten verarbeiten.</p>
<p>Dazu wählen wir im oberen Bereich <code v-pre>Kontextmenü &gt; Daten verarbeiten...</code></p>
<p>Im Hintergrund werden die Daten importiert und Ereignisse, Merkmale und Publikationen erstellt.</p>
<p><img src="@source/tutorial/i/adressimport/09_verarbeiten.png" alt=""></p>
<h3 id="schritt-7-uberprufen" tabindex="-1"><a class="header-anchor" href="#schritt-7-uberprufen"><span>Schritt 7: Überprüfen</span></a></h3>
<p>Nachdem der Hintergrundjob fertig ist, können wir die Ansicht aktualisieren (über das Kontextmenü oder in der Toolbar) und uns die Personen anschauen.</p>
<p><img src="@source/tutorial/i/adressimport/10_verarbeitet.png" alt=""></p>
<p>Um die Details der Person zu sehen, können wir auch <code v-pre>Kontextmenü &gt; Gehe zu &gt; Person</code> wählen und so direkt zur Person springen.
<img src="@source/tutorial/i/adressimport/11_ueberpruefen.png" alt=""></p>
<p>Wir sehen, dass Martina das Ereignis ihrer Spende (Umsatzchart), die Publikation (angewählt) sowie das Merkmal (oben rechts im Konfigurierbaren-Bereich sichtbar) erhalten hat.</p>
</div></template>


